// D80 Tier 2 — Video block (custom TipTap Node).
// Renders an inline <video controls> with a download link below.
// The node is `atom`-like at the schema level (no editable text inside)
// but stays selectable + draggable so the global DragHandle works.
import { Node, mergeAttributes } from '@tiptap/core';

export const VideoEmbed = Node.create({
  name: 'videoEmbed',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,
  addAttributes() {
    return {
      src: { default: null },
      name: { default: '' },
      mime_type: { default: 'video/mp4' },
      size: { default: 0 },
      poster: { default: null },
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="video-embed"]' }];
  },
  renderHTML({ node, HTMLAttributes }) {
    const { src, name, mime_type, poster } = node.attrs;
    const attrs = mergeAttributes(HTMLAttributes, {
      'data-type': 'video-embed',
      class: 'stellar-video-embed',
      'data-name': name || '',
    });
    return [
      'div', attrs,
      ['video', {
        controls: 'true', src: src || '', preload: 'metadata',
        ...(poster ? { poster } : {}),
        style: 'max-width:100%;max-height:480px;border-radius:8px;display:block;',
      }],
      ['div', { class: 'stellar-media-caption' },
        ['span', { class: 'stellar-media-name' }, name || 'Video'],
        ['a', {
          href: src || '#', download: name || 'video',
          target: '_blank', rel: 'noopener noreferrer',
          class: 'stellar-media-download', 'data-testid': 'video-download',
        }, 'Download'],
      ],
    ];
  },
  addCommands() {
    return {
      insertVideo: (attrs) => ({ commands }) =>
        commands.insertContent({ type: this.name, attrs }),
    };
  },
});
